import _ from "lodash";
import { Dashboard } from "../../gateway/Dashboard/Dashboard";
import { Visualization } from "../../gateway/Visualization/Visualization";
import { HttpAdapter } from "../../main/adapters/HttpAdapter";
import { CompressedJsonAdapter } from "../../presentation/adpters/CompressedJsonAdapter/CompressedJsonAdapter";
import { PopulateManager } from "../../presentation/services/PopulateManager/PopulateManager";
import { Available } from "../Available/Available";
import { Serie } from "../Serie/Serie";
import { PointMap } from "./PointMap";
let calculatedSeriePointsMap = new Map();
export class CalculatingMachineV2Gateway {
    HttpAdapter = new HttpAdapter();
    baseUrl = `${publicSettings.aws.baseUrls.dataTimeseries}`;

    constructor() {
        this.compressJsonAdapter = new CompressedJsonAdapter();
        this.Available = new Available();
        this.populateManager = new PopulateManager();
        this.serieCollection = new Serie({
            PopulateManager: this.populateManager
        });
        this.Dashboard = new Dashboard({
            Visualization: new Visualization(),
            Serie: this.serieCollection
        });
    }

    validateInput({ companyData, source, analyzeGroup, analysisPeriod }) {
        if (!companyData) throw new Error(`Missing params: companyData`);
        if (!source) throw new Error(`Missing params: source`);
        if (analyzeGroup && !["sum", "average"].includes(analyzeGroup))
            throw new Error(`Invalid params: analyzeGroup`);
        if (
            analysisPeriod &&
            !["monthly", "quarterly", "semester", "yearly"].includes(
                analysisPeriod
            )
        )
            throw new Error(`Invalid params: analyzeGroup`);
    }

    getParans({
        companyData,
        source,
        scenarioId,
        analyzeGroup,
        analysisPeriod,
        isScenarioView
    }) {
        if (!scenarioId) scenarioId = "ORIGINAL";
        if (!analyzeGroup) analyzeGroup = "sum";
        if (!analysisPeriod) analysisPeriod = "monthly";
        const accountingId = companyData.accountingId;
        const companyId = companyData._id;
        const isAnalysisCashFlow =
            source == "fin" &&
            companyData?.relation?.contaazul?.type === "cashFlow";
        const countGroupCompanies = companyData?.companyIds?.length || 0;

        return {
            accountingId,
            companyId,
            source,
            scenarioId,
            analyzeGroup,
            isAnalysisCashFlow,
            analysisPeriod,
            countGroupCompanies,
            isScenarioView: isScenarioView || false
        };
    }

    /**
     *
     * @param {
     *  companyData: { _id, accountingId, relation, companyIds },
     *  source: string,
     *  analysisPeriod?: [monthly | quarterly| semester | yearly]
     *  analyzeGroup?: ["sum", "average"]
     *  scenarioId?: string
     *  years number[]
     * } parans
     * @returns
     */
    async calculateSeries({
        companyData,
        source,
        scenarioId,
        analyzeGroup,
        analysisPeriod,
        currentDate,
        startDate,
        currentComparation,
        availableFilter,
        ignoreRaw = false,
        multipleSource = false,
        isScenarioView = false,
        allMonthsByYear = false,
        projection,
        totalMonthsProjection = 12,
        budget = false,
        allYearsAvailable = false,
        goals,
        dashboardId = false,
        goalsIds,
        seriesIds,
        preserveMap = true
    }) {
        this.validateInput({
            companyData,
            source,
            analyzeGroup,
            analysisPeriod
        });
        const parans = this.getParans({
            companyData,
            source,
            scenarioId,
            analyzeGroup,
            analysisPeriod,
            isScenarioView
        });
        try {
            let timesAvailable = [];
            if (startDate) {
                timesAvailable = this.Available.getAvailableByIntervals({
                    companyId: parans.companyId,
                    source: parans.source,
                    scenarioId: parans.scenarioId,
                    startDate,
                    currentDate,
                    currentComparation,
                    projection,
                    budget
                });
            } else {
                timesAvailable = this.Available.getByFilterDate({
                    companyId: parans.companyId,
                    source: parans.source,
                    scenarioId: parans.scenarioId,
                    currentDate,
                    currentComparation,
                    availableFilter,
                    analysisPeriod,
                    allMonthsByYear,
                    projection,
                    budget,
                    allYearsAvailable
                });
            }
            timesAvailable = this._sanitizeTimesAvailable(timesAvailable);
            if (!timesAvailable.length) return;
            const input = {
                compressed: true,
                company: {
                    _id: companyData._id,
                    accountingId: companyData.accountingId,
                    companyIds: companyData.companyIds,
                    relation: companyData.relation
                },
                timesAvailable,
                options: {
                    totalGroupCompanies: companyData.companyIds
                        ? companyData.companyIds.length
                        : 0,
                    isScenarioView,
                    isCashFlow: parans.isCashFlow,
                    scenarioId: parans.scenarioId,
                    period: parans.analysisPeriod,
                    groupFilterOper: parans.analyzeGroup
                }
            };
            if (goals) {
                input.goalsIds = this._getGoalsIds(
                    companyData._id,
                    parans.source,
                    dashboardId,
                    goalsIds
                );
            } else {
                input.seriesIds = _.uniq(
                    this.getSeriesIds({
                        ...parans,
                        ignoreRaw,
                        multipleSource,
                        projection,
                        dashboardId,
                        seriesIds
                    }).filter((s) => s)
                );
            }

            if (projection) {
                if (projection != "PROGRESSAO_LINEAR")
                    input.options.scenarioId = projection;
                else {
                    input.options.projection = {
                        scenarioId: projection,
                        totalMonths: totalMonthsProjection
                    };
                }
            }
            const calculatedPoints = await this.calculatrixPaginateBySeriesIds(
                input
            );
            const mapPersistance = preserveMap
                ? calculatedSeriePointsMap
                : new Map();
            calculatedSeriePointsMap = PointMap.generateMap(
                calculatedPoints,
                mapPersistance,
                { projection: projection, scenarioIdBase: parans.scenarioId }
            );
        } catch (error) {
            console.error("CalculatingMachineV2Gateway", error);
        }
    }

    _getGoalsIds(companyId, source, dashboardId, goalsIds) {
        if (goalsIds?.length) {
            if (source == "accounting") {
                const ids = this.serieCollection
                    .findCollection(
                        { referenceId: { $in: goalsIds } },
                        {},
                        "array"
                    )
                    .map((g) => g._id);
                return ids;
            } else {
                return goalsIds;
            }
        }
        if (dashboardId) {
            const _golasIds = this.Dashboard.getSeriesInUse(
                dashboardId,
                "goals",
                goalsIds
            );
            if (_golasIds.length) return _golasIds;
        }

        if (source == "accounting") companyId = "EMPRESA_NUCONT";
        const series = this.serieCollection.findCollection(
            {
                sources: source,
                companyId,
                "metadata.origin": "goals"
            },
            {},
            "array"
        );
        return series.map((s) => s._id);
    }

    async calculatrixPaginateBySeriesIds(input) {
        if (input.seriesIds?.length) {
            const seriesIds = input.seriesIds;
            const pointsResponse = [];
            const pageSize = 200;
            const numberOfPages = Math.ceil(seriesIds.length / pageSize);
            const requests = [];
            for (let i = 0; i < numberOfPages; i++) {
                const startIdx = i * pageSize;
                const endIdx = (i + 1) * pageSize;
                const seriesSubset = seriesIds.slice(startIdx, endIdx);
                const requestPromise = this.HttpAdapter.call(
                    `${this.baseUrl}/calculatrix/calculate`,
                    { ...input, seriesIds: seriesSubset }
                );
                requests.push(requestPromise);
            }

            try {
                const responses = await Promise.all(requests);
                responses.forEach((r) => {
                    const calculatedPoints = this._extractCalculatedPoints(r);
                    pointsResponse.push(...calculatedPoints);
                });
            } catch (error) {
                console.error("Erro ao fazer chamadas paginadas:", error);
            }
            return pointsResponse;
        } else if (input.goalsIds?.length) {
            const pointsResponse = await this.HttpAdapter.call(
                `${this.baseUrl}/calculatrix/calculate`,
                input
            );
            return this._extractCalculatedPoints(pointsResponse);
        }
    }

    /**
     *
     * @param {*} parans
     * @returns string[]
     */
    getSeriesIds({
        multipleSource,
        companyId,
        source,
        dashboardId,
        ignoreRaw,
        countGroupCompanies,
        projection,
        seriesIds
    }) {
        if (seriesIds?.length) return seriesIds;
        if (dashboardId) {
            const serieIds = this.Dashboard.getSeriesInUse(dashboardId);
            if (source === "accounting") {
                serieIds.push("tAnrDEqRR2hto1ev7");
            }
            if (serieIds.length) return serieIds;
        }
        let selectSeries = {
            companyId: { $in: [companyId, "EMPRESA_NUCONT"] },
            sources: source
        };
        if (ignoreRaw) {
            selectSeries.type = { $ne: "raw" };
        }
        if (countGroupCompanies > 0) {
            selectSeries = {
                $or: [
                    { groupId: companyId },
                    {
                        companyId: {
                            $in: [companyId, "EMPRESA_NUCONT"]
                        }
                    }
                ],
                sources: source
            };
        }
        if (source === "accounting") {
            selectSeries.sources = { $in: ["accounting", "custom"] };
        }
        const taxSources = ["simplesNacional", "tax"];
        const personnelSources = ["personnel", "eSocial"];
        const sourceCobination = [...taxSources, ...personnelSources];
        if (multipleSource && sourceCobination.includes(source)) {
            if (taxSources.includes(source)) {
                selectSeries.sources = {
                    $in:
                        projection === "PROGRESSAO_LINEAR"
                            ? [source]
                            : taxSources
                };
            } else if (personnelSources.includes(source)) {
                selectSeries.sources = {
                    $in:
                        projection === "PROGRESSAO_LINEAR"
                            ? [source]
                            : personnelSources
                };
            }
        }
        const series = this.serieCollection.findCollection(
            selectSeries,
            {},
            "array"
        );
        return series
            .filter((s) => s?.metadata?.origin !== "goals")
            .map((s) => s._id);
    }

    setDrillerPoints(pointsDrillers) {
        calculatedSeriePointsMap = PointMap.generateMap(
            pointsDrillers,
            calculatedSeriePointsMap
        );
    }

    getCalculatedSeriePointsMap() {
        return calculatedSeriePointsMap;
    }

    _sanitizeTimesAvailable(timesAvailable) {
        if (!timesAvailable?.length) return [];
        return timesAvailable.filter((time) => time != null);
    }

    _extractCalculatedPoints(response) {
        if (response?.compressed) {
            return this.compressJsonAdapter.decompress(response.response);
        } else {
            return response;
        }
    }

    getCalculatedSeriesPoints(
        seriesIds,
        time,
        scenarioId,
        period,
        visualizationAccumulated
    ) {
        const series = this.serieCollection.findCollection(
            {
                _id: { $in: seriesIds }
            },
            {},
            "array"
        );

        return PointMap.findPoints(
            calculatedSeriePointsMap,
            series,
            scenarioId,
            period,
            time,
            visualizationAccumulated
        );
    }

    getCalculatedSeriesPointsInRange(
        serieIds,
        scenarioId,
        period,
        timesBetween,
        visualizationAccumulated
    ) {
        const series = this.serieCollection.findCollection(
            {
                _id: { $in: serieIds }
            },
            {},
            "array"
        );

        return PointMap.findPointsInTimeRange(
            calculatedSeriePointsMap,
            series,
            scenarioId,
            period,
            timesBetween,
            visualizationAccumulated
        );
    }
}
